import { apiV0 } from './apiClient';

/**
 * API para gestión de usuarios del sistema
 * Centraliza todas las llamadas relacionadas con usuarios
 *
 * NOTA: Aún usa apiV0 porque el endpoint no ha migrado a V1.
 * El endpoint está en /api/usuarios-admin (no /api/v1/usuarios-admin)
 */
const usuariosApi = {
  /**
   * GET /api/usuarios-admin
   * Listar todos los usuarios del sistema
   */
  listar: async () => {
    const response = await apiV0.get('/usuarios-admin');
    return response.data;
  },

  /**
   * GET /api/usuarios-admin/:id
   * Obtener un usuario por ID
   */
  obtener: async (id) => {
    const response = await apiV0.get(`/usuarios-admin/${id}`);
    return response.data;
  },

  /**
   * POST /api/usuarios-admin
   * Crear un nuevo usuario
   */
  crear: async (data) => {
    const response = await apiV0.post('/usuarios-admin', data);
    return response.data;
  },

  /**
   * PUT /api/usuarios-admin/:id
   * Actualizar un usuario existente
   */
  actualizar: async (id, data) => {
    const response = await apiV0.put(`/usuarios-admin/${id}`, data);
    return response.data;
  },

  /**
   * DELETE /api/usuarios-admin/:id
   * Eliminar (desactivar) un usuario
   */
  eliminar: async (id) => {
    const response = await apiV0.delete(`/usuarios-admin/${id}`);
    return response.data;
  }
};

export default usuariosApi;
